import React from 'react';
import styles from './DroneSpecifications.module.css';

const DroneSpecifications = ({ 
  specifications = [], 
  droneImage, 
  title, 
  description 
}) => {
  // Check if specifications is an array of strings
  const isStringArray = specifications && specifications.length > 0 && typeof specifications[0] === 'string';

  return (
    <section className={styles.specificationsSection}>
      <div className={styles.contentContainer}>
        
        {/* Header Section */}
        {(title || description) && (
          <div className={styles.headerSection}>
            {title && (
              <h3 className={styles.mainTitle}>{title}</h3>
            )}
            
            {description && (
              <p className={styles.description}>{description}</p>
            )}
          </div>
        )}
        
        {/* Drone Image Section */}
        {droneImage && (
          <div className={styles.imageSection}>
            <img 
              src={droneImage} 
              alt={title || "Drone Specifications"} 
              className={styles.droneImage}
              loading="lazy"
              width="640"
              height="400"
            />
          </div>
        )}

        {/* Specifications Section */}
        <div className={styles.specificationsContainer}>
          <h3 className={styles.specificationsTitle}>Specifications</h3>
          
          <div className={styles.specificationsList}>
            {isStringArray ? (
              // Handle array of strings as bullet points
              specifications.map((item, index) => (
                <div key={index} className={styles.bulletItem}>
                  <span className={styles.bulletPoint}></span>
                  <p className={styles.bulletText}>{item}</p>
                </div>
              ))
            ) : (
              // Handle array of objects as label-value pairs
              specifications?.map((item, index) => (
                <div key={index} className={styles.specificationContent}>
                  <p className={styles.specLabel}>{item.label}</p>
                  <p className={styles.specValue}>{item.value}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DroneSpecifications;